import cloneDeep from 'lodash/cloneDeep'
import twoCirclesCrossed from '@/assets/lottie/two-circles-crossed.json'

/*
    lottie accepts colors in specific numeric format,
    to translate rgb color to lottie need to create an array and divide each color to 255.
    formula: rgba(r, g, b, alpha) -> [r/255, g/255, b/255, alpha]
*/
export const hexToLottieColor = (hex) => {
    if (typeof hex !== 'string' || !hex.length) return

    const hexCode = hex.replace('#', '').toUpperCase()

    return [
        parseInt(`${hexCode[0]}${hexCode[1]}`, 16) / 255,
        parseInt(`${hexCode[2]}${hexCode[3]}`, 16) / 255,
        parseInt(`${hexCode[4]}${hexCode[5]}`, 16) / 255,
        1
    ]
}

export const getCircleAnimationData = ({
    isCrossed,
    isTwoLines,
    bgColor,
    primaryColor,
    secondaryColor,
    primaryPrecentageEnd,
    primaryPrecentageStart,
    seconadaryPrecentageEnd,
    seconadaryPrecentageStart
}) => {
    const data = cloneDeep(twoCirclesCrossed)

    data.layers[0].shapes[0].it[1].c.k = hexToLottieColor(primaryColor) //  bottom bar color

    data.layers[1].ef[0].ef[0].v.k[0].s = [primaryPrecentageStart] // second line start from length
    data.layers[1].ef[0].ef[0].v.k[1].s = [primaryPrecentageEnd] // primary line length
    data.layers[1].shapes[0].it[1].c.k = hexToLottieColor(primaryColor) // primary line color

    data.layers[2].ef[0].ef[0].v.k[1].s = [seconadaryPrecentageEnd] // second line length
    data.layers[2].ef[0].ef[0].v.k[0].s = [seconadaryPrecentageStart] // second line start from length
    data.layers[2].shapes[0].it[1].c.k = hexToLottieColor(secondaryColor) // second line color

    data.layers[3].shapes[0].it[1].c.k = hexToLottieColor(bgColor) // bg circle color (has own opacity)

    if (!isTwoLines) data.layers[2] = {} // remove second line
    if (!isCrossed) data.layers[0] = {} // remove bottom bar

    return data
}
